import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import LanguageSelectionTab from "./LanguageSelectionTab";
import TranslationApprovalsTab from "./TranslationApprovalsTab";

export default function TranslationManagementPage(props) {
  const history = useHistory();
  const location = useLocation();

  // Get procedure info from navigation state, with fallback to localStorage
  const state = location.state || {};
  const procedureId = state.procedureId || localStorage.getItem("procedureId");
  const procedureName = state.procedureName || localStorage.getItem("procedureName") || "";

  const [activeTab, setActiveTab] = useState("languages");

  if (!procedureId) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px" }}>
        <p style={{ fontSize: "16px", color: "#e74c3c" }}>Error: No procedure ID provided</p>
        <button onClick={() => history.goBack()} style={{ padding: "10px 20px", background: "#667eea", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" }}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div style={{ background: "#F9F9FB" }}>
      <ToastContainer className="Toast-at-center" />

      {/* Content Header - Sticky */}
      <div style={{ borderBottom: "1px solid #e8eef5", paddingBottom: "16px", marginBottom: "0", marginLeft: "1vw", position: "sticky", top: "0", background: "#F9F9FB", zIndex: "10" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "16px" }}>
          <button
            onClick={() => history.goBack()}
            style={{
              background: "none",
              border: "none",
              fontSize: "48px",
              cursor: "pointer",
              color: "#333",
              padding: "8px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: "1",
              minWidth: "60px",
              minHeight: "60px"
            }}
            title="Back to Treatment"
          >
            ←
          </button>
          <div>
            <h1 style={{ fontSize: "20px", fontWeight: "600", color: "#333", margin: "0 0 0 0" }}>Translation Management</h1>
            <p style={{ fontSize: "14px", color: "#666", margin: "4px 0 0 0" }}>For {procedureName}</p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ marginLeft: "1vw", paddingTop: "0", position: "sticky", top: "80px", background: "#F9F9FB", zIndex: "9" }}>
        <div style={{ display: "flex", gap: "0", borderBottom: "2px solid #e8eef5" }}>
          <button
            onClick={() => setActiveTab("languages")}
            style={{
              padding: "14px 20px",
              background: "none",
              border: "none",
              fontSize: "14px",
              fontWeight: activeTab === "languages" ? "600" : "500",
              color: activeTab === "languages" ? "#282a65" : "#999",
              borderBottom: activeTab === "languages" ? "3px solid #282a65" : "none",
              cursor: "pointer",
              transition: "all 0.2s ease",
              marginBottom: "-2px"
            }}
            onMouseEnter={(e) => e.target.style.color = "#282a65"}
            onMouseLeave={(e) => e.target.style.color = activeTab === "languages" ? "#282a65" : "#999"}
          >
            Language Selection
          </button>
          <button
            onClick={() => setActiveTab("content")}
            style={{
              padding: "14px 20px",
              background: "none",
              border: "none",
              fontSize: "14px",
              fontWeight: activeTab === "content" ? "600" : "500",
              color: activeTab === "content" ? "#282a65" : "#999",
              borderBottom: activeTab === "content" ? "3px solid #282a65" : "none",
              cursor: "pointer",
              transition: "all 0.2s ease",
              marginBottom: "-2px"
            }}
            onMouseEnter={(e) => e.target.style.color = "#282a65"}
            onMouseLeave={(e) => e.target.style.color = activeTab === "content" ? "#282a65" : "#999"}
          >
            Translation Approvals
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ padding: "20px 28px", maxWidth: "100%", margin: "0" }}>
        {activeTab === "languages" && (
          <LanguageSelectionTab
            procedureId={procedureId}
            activeTab={activeTab}
          />
        )}

        {activeTab === "content" && (
          <TranslationApprovalsTab
            procedureId={procedureId}
            activeTab={activeTab}
          />
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/TranslationManagementPage.js